import { useQuery } from '@tanstack/react-query';
import { projectsLeanQuery } from '@/lib/publicQueries';

export const useProjects = (options: { publicOnly?: boolean; limit?: number } = {}) => {
  return useQuery(projectsLeanQuery(options));
};
